// src/pages/Confirmacao.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/compra.css";

const Confirmacao = () => {
    const navigate = useNavigate();

    return (
        <div className="compra-container">
            <h2>✅ Pedido Confirmado!</h2>
            <p>Seu pagamento foi processado com sucesso.</p>

            <button onClick={() => navigate("/")}>Voltar ao Início</button>
        </div>
    );
};

export default Confirmacao;
